import {
  Box,
  Button,
  CircularProgress,
  Container,
  Divider,
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';
import React, { memo, useContext, useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { LiveContainer } from '../../../live/LiveContainer';
import CoChip from '../../../shared/components/ui/CoChip';
// import CoChipSmall from '../../../shared/components/ui/CoChipSmall';
import CoChipSmall from '@/js/shared/components/ui/CoChipSmall';
import UserAvatar from '../../../shared/components/ui/UserAvatar';
import { ConferenceContext } from '../../../shared/context/ConferenceContext';
import { UserContext } from '../../../shared/context/UserContext';
import { useCoeolytics } from '@/js/shared/context/CoeolyticsHooks';
import { infoList } from '@/js/shared/utils/DataFormat';
import { useParticipantList } from '@/hooks/useParticipantList';
import SearchBar from '@/js/shared/components/ui/SearchBar';
import { useParticipantTags } from '@/hooks/useParticipantTags';
import { ParticipantTagSorter } from './ParticipantTagSorter';

const particpantStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    // flexDirection: 'row',
    // justifyContent: 'strech',
  },
  bg: {
    flexGrow: 1,
    overflow: 'hidden',
    cursor: 'pointer',
    backgroundColor: () => {
      return theme.palette.background.default === '#ffffff'
        ? theme.palette.background.shadedown_10
        : theme.palette.background.shadeup_10;
    },
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: theme.palette.background.shadedown_20,
    boxShadow: '1px 2px 1px 0px rgb(0, 0, 0, 0.2)',
    borderRadius: 3,
    padding: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.background.shadedown_20,
      boxShadow: '1px 2px 1px 0px rgb(0, 0, 0, 0.4)',
    },
  },
  name: {
    fontSize: '0.9rem',
    fontWeight: 'bold',
  },
  info: {
    fontSize: '0.8rem',
    fontStyle: 'italic',
  },
  avatarHolder: {
    position: 'relative',
  },
  isOnline: {
    display: 'inline-block',
    backgroundColor: '#000000aa',
    padding: '2px 5px 3px 15px',
    color: '#fff',
    borderRadius: 12,
    fontSize: 10,
    lineHeight: '11px',
    position: 'absolute',
    top: 40,
    left: 3,
    width: 48,
    '&::before': {
      position: 'absolute',
      top: 5,
      left: 5,
      content: '""',
      display: 'block',
      width: 6,
      height: 6,
      borderRadius: 6,
      backgroundColor: '#29ff00',
    },
  },
}));

const ParticipantCard = memo(({ user, userlist }) => {
  const { openUserPopup } = useContext(ConferenceContext);

  const classes = particpantStyles();
  const handleUserClick = (user) => {
    openUserPopup(user, userlist);
  };
  return (
    <Grid
      item
      xs={12}
      sm={6}
      lg={4}
      onClick={() => handleUserClick(user)}
      className={classes.card}
    >
      <Paper className={classes.bg} elevation={2} boxShadow={1}>
        <Box display="flex" alignItems="flex-start">
          <Box className={classes.avatarHolder}>
            <UserAvatar user={user} size="medium2" />{' '}
            {user.online && <div className={classes.isOnline}>online</div>}
          </Box>

          <Box flexGrow={1} pl={1}>
            <div className={classes.name}>{user.full_name}</div>

            <div className={classes.info}>
              {infoList([user.title, user.company, user.location_city])}
            </div>
          </Box>
        </Box>
        <Box flexGrow={1}>
          {user.tags
            .map((tag) => (
              <CoChipSmall
                size="smaller"
                key={tag.id}
                tagtype={tag.type}
                label={tag.title}
              />
            ))
            .reduce((r, a) => r.concat(', ', a), [])
            .slice(1)}
        </Box>
      </Paper>
    </Grid>
  );
});

const useStyles = makeStyles(() => ({}));

const Participants = withRouter((props) => {
  // const classes = useStyles();
  const coeoLytics = useCoeolytics();

  const { userState, actions } = useContext(UserContext); // Hämta Context
  const { conferenceState } = useContext(ConferenceContext);
  const moreButtonRef = useRef();

  const {
    participants,
    totalCount,
    loading,
    fullList,
    keyword,
    loadParticipants,
    showMore,
    handleSearch,
    filterByTag,
  } = useParticipantList({
    conferenceId: window.CONFERENCE_ID,
    programRoomId: null,
  });

  const { tagList } = useParticipantTags({
    participants: fullList,
    conferenceTags: conferenceState.conferenceDetail.tags,
  });

  // const [tagList, setTagList] = useState([]);
  const [selectedTag, setSelectedTag] = useState(null);

  const observer = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      showMore();
    }
  });

  useEffect(() => {
    if (fullList.length > 0) {
      setTimeout(() => {
        // Ugly hack
        observer.observe(moreButtonRef.current); // Check for the LOAD MORE button
      }, 500);
    }
  }, [fullList.length]);

  useEffect(() => {
    if (props.history.action == 'PUSH') {
      coeoLytics.page();
    }
  }, []);

  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll);
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);

  const selectTag = (tagId) => {
    setSelectedTag(selectedTag === tagId ? null : tagId);
  };
  useEffect(() => {
    loadParticipants();
  }, []);

  // useEffect(() => {
  //   if (fullList.length > 0) {
  //     let mappedTags = fullList
  //       .reduce(function (acc, user) {
  //         return acc.concat(user.tags.map((tag) => tag.id));
  //       }, [])
  //       .reduce(function (acc, curr) {
  //         if (!acc.hasOwnProperty(curr)) {
  //           acc[curr] = 1;
  //         } else {
  //           acc[curr] += 1;
  //         }
  //         return acc;
  //       }, {});

  //     const tagsCounted = conferenceState.conferenceDetail.tags.map((tag) => {
  //       return { ...tag, count: mappedTags[tag.id] || 0 };
  //     });

  //     setTagList([
  //       ...tagsCounted.filter((t) => t.type === 'skill'),
  //       ...tagsCounted.filter((t) => t.type === 'scouting'),
  //     ]);
  //   }
  // }, [fullList.length]);

  const onFocusChange = () => {
    setSelectedTag(null);
  };
  useEffect(() => {
    filterByTag(selectedTag);
  }, [selectedTag]);

  return (
    <LiveContainer
      isActive={(to) => {
        return to === `/live/participants`;
      }}
    >
      <Container>
        <Box p={1}>
          <Box py={1}>
            <Container maxWidth="md">
              <ParticipantTagSorter
                tagList={tagList}
                selectedTag={selectedTag}
                selectTag={selectTag}
              />
              <Box pb={1}>
                <SearchBar
                  onFocusChange={onFocusChange}
                  onSearch={handleSearch}
                  keyword={keyword}
                />
              </Box>
            </Container>
            <Box>
              <Grid
                container
                spacing={1}
                alignItems="stretch"
                justifyContent="center"
              >
                {participants.map((user) => (
                  <ParticipantCard
                    key={user.id}
                    user={user}
                    userlist={participants}
                  />
                ))}
              </Grid>
              {loading ? (
                <Box textAlign="center">
                  <CircularProgress />
                </Box>
              ) : (
                totalCount > participants.length && (
                  <Box align="center">
                    <Button
                      size="small"
                      color="primary"
                      onClick={showMore}
                      ref={moreButtonRef}
                    >
                      Load more
                    </Button>
                  </Box>
                )
              )}
            </Box>
          </Box>
        </Box>
      </Container>
    </LiveContainer>
  );
});

export default Participants;
